abcsetup.promos = abcsetup.promos || {};
abcsetup.promos.plans = abcsetup.promos.plans || {};


///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Methods
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.promos.plans.index = {
    init: function() {
        $('[data-toggle="tooltip"]').tooltip();
        this.initListeners();
    },
    initListeners: () => {
    }
}
